/**
 * Canonical Problem Details `type` URIs (RFC 9457) from the SmartBear problems
 * registry, centralized so the string literals live in one place instead of
 * being repeated (and drifting, e.g. with/without a trailing slash) across the
 * error-message mappers.
 */
export const PROBLEM_TYPES = {
  BAD_REQUEST: "https://problems-registry.smartbear.com/bad-request/",
  MISSING_BODY_PROPERTY:
    "https://problems-registry.smartbear.com/missing-body-property/",
  INVALID_BODY_PROPERTY_FORMAT:
    "https://problems-registry.smartbear.com/invalid-body-property-format/",
  MISSING_REQUEST_PARAMETER:
    "https://problems-registry.smartbear.com/missing-request-parameter/",
  NOT_FOUND: "https://problems-registry.smartbear.com/not-found/",
  ALREADY_EXISTS: "https://problems-registry.smartbear.com/already-exists/",
  CONFLICT: "https://problems-registry.smartbear.com/conflict/",
  FORBIDDEN: "https://problems-registry.smartbear.com/forbidden/",
  UNAUTHORIZED: "https://problems-registry.smartbear.com/unauthorized/",
  SERVER_ERROR: "https://problems-registry.smartbear.com/server-error/",
} as const;
